/* src/components/settings/sections/TrainingLevelSettings.js */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faSpinner } from '@fortawesome/free-solid-svg-icons';
import {
    SectionCard,
    DropdownInput,
    SliderInput
} from '../SettingSectionComponents';
// No LoadingSpinner needed for the save button here, as faSpinner is used directly.

const TrainingLevelSettings = ({
    activeProfile,
    localNBack,
    onNBackChange, // This will be (e) => setLocalNBack(e.target.value)
    nBackOptions,
    localDifficultySliderValue,
    onDifficultySliderChange, // This will be (e) => setLocalDifficultySliderValue(parseInt(e.target.value, 10))
    displayedCombinedLevel,
    isLevelSectionDisabled,
    levelValidationError,
    isSavingLevel,
    levelSaveStatus,
    onRequestLevelChange
}) => {
    return (
        <SectionCard title="Training Level" icon={faBrain}>
            {!activeProfile ? (
                <p className="text-sm text-gray-500 italic">Select an active profile to adjust training level.</p>
            ) : (
                <>
                    <p className="text-sm text-gray-600 mb-4">
                        Manually set the starting N-Back level and difficulty component for your next standard training session. The system normally adjusts this automatically.
                    </p>
                    <div className="space-y-3 divide-y divide-gray-200">
                        {/* N-Back Dropdown */}
                        <DropdownInput
                            label="N-Back Level"
                            id="nBackLevel"
                            value={localNBack}
                            onChange={onNBackChange}
                            options={nBackOptions}
                            disabled={isLevelSectionDisabled}
                            className="pt-3"
                        />
                        {/* Difficulty Slider */}
                        <SliderInput
                            label="Level Difficulty"
                            id="difficultyLevel"
                            value={String(localDifficultySliderValue)}
                            onChange={onDifficultySliderChange}
                            min="0"
                            max="99" // Slider goes 0-99
                            step="1"
                            disabled={isLevelSectionDisabled}
                            displayValue={displayedCombinedLevel} // Displays N + 0.XX
                        />
                    </div>
                    {levelValidationError && (
                        <p className="mt-3 text-sm text-red-600">{levelValidationError}</p>
                    )}
                    {/* Save Button Area for Level Settings */}
                    <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-end space-x-3">
                        {levelSaveStatus.message && (
                            <span className={`text-sm font-medium ${levelSaveStatus.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                                {levelSaveStatus.message}
                            </span>
                        )}
                        <button
                            onClick={onRequestLevelChange}
                            disabled={isLevelSectionDisabled || !!levelValidationError}
                            className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 disabled:opacity-50 transition-colors flex items-center justify-center min-w-[120px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                        >
                            {isSavingLevel ? (
                                <><FontAwesomeIcon icon={faSpinner} className="animate-spin -ml-1 mr-2 h-4 w-4" /> Saving...</>
                            ) : (
                                'Save Level'
                            )}
                        </button>
                    </div>
                </>
            )}
        </SectionCard>
    );
};

export default TrainingLevelSettings;